/**
 * Le point d'entrée de WebMCP, seul endroit du site qui touche à l'API.
 *
 * WebMCP permet à une page de déclarer des outils qu'un assistant IA piloté
 * par le navigateur appelle directement, au lieu de cliquer à la place du
 * joueur (https://github.com/webmachinelearning/webmcp). La spécification
 * bouge encore : l'objet a été renommé de navigator.modelContext en
 * document.modelContext, et les premières versions de Chrome désinscrivaient
 * par unregisterTool(nom) plutôt que par un signal. Les deux formes sont
 * acceptées ici ; quand l'API changera de nouveau, c'est ce fichier qu'on
 * retouche.
 *
 * Ce module reste dans le bundle principal et ne pèse que quelques lignes :
 * les outils eux-mêmes ne se chargent que si getModelContext() répond.
 */

export function getModelContext() {
    if (typeof document === "undefined") return null;
    const context = document.modelContext ?? globalThis.navigator?.modelContext;
    return typeof context?.registerTool === "function" ? context : null;
}

/**
 * Enregistre une liste d'outils et rend de quoi les retirer tous.
 * Un outil que le navigateur refuse n'empêche pas les autres d'être déclarés.
 */
export function registerTools(context, tools) {
    const controller = new AbortController();
    const names = [];
    for (const tool of tools) {
        try {
            const pending = context.registerTool(tool, { signal: controller.signal });
            names.push(tool.name);
            Promise.resolve(pending).catch((error) => {
                console.warn(`[agent] outil ${tool.name} refusé :`, error);
            });
        } catch (error) {
            console.warn(`[agent] outil ${tool.name} refusé :`, error);
        }
    }
    return () => {
        controller.abort();
        if (typeof context.unregisterTool !== "function") return;
        for (const name of names) {
            try {
                context.unregisterTool(name);
            } catch {
                // Déjà retiré par le signal : rien à faire.
            }
        }
    };
}

/** L'origine du site pour les liens rendus aux assistants, lue à l'appel. */
export const siteOrigin = () => window.location.origin;

/** La réponse d'un outil, au format que les assistants attendent (MCP). */
export function toolResult(data) {
    return { content: [{ type: "text", text: JSON.stringify(data) }] };
}

/** Une erreur que l'assistant peut lire et rapporter au joueur. */
export function toolError(message) {
    return { content: [{ type: "text", text: message }], isError: true };
}
